let abc = (a, b) => {

  if (a === b) {
    return 0;
  }

  if (a > b) {
    return 1;
  }

  return -1;

};

let castToInt = (items) => {
  let i = items.length;

  while (i--) {
    items[i] = 1 * items[i];
  }

  return items;
};

export default class PathGenerator
{

  constructor(game)
  {
    this.game = game;

    this.paths = [];

  }

  garbageCollect() {
    this.paths.splice();
  }

  // returns one of the 2 or more lowest points
  findSouthernMostPoint()
  {

    let lowest = [];
    let y = null;

    this.game.points.forEach(point => {
      if (y === null || point.y > y) {
        y = point.y;
        lowest = [point];
        return;
      }
      if (y === point.y) {
        lowest.push(point);
      }
    });

    lowest.sort((a, b) => {
      if (a.x === b.x) { return 0; }
      if (a.x > b.x) { return -1; }
      return 1;
    });

    return lowest[0];

  }

  generate()
  {

    this.game.rooms.forEach(room => {

      let distance = 50;
      let doorPoint = 100;

      // left top
      this.proposePoint(room.x - distance, room.y - distance);

      // door left
      let a = this.proposePoint(room.x - distance, room.y + doorPoint, room);
      let b = this.proposePoint(room.x + 5, room.y + doorPoint, room);

      this.paths.push({a, b, force: true});

      room.doorPoint = b;

      // right top
      this.proposePoint(room.x + room.width + distance, room.y - distance);

      // left bottom
      this.proposePoint(room.x - distance, room.y + room.height + distance);

      // right bottom
      this.proposePoint(room.x + room.width + distance, room.y + room.height + distance);

    });





    this.generatePaths();

    // @todo: uncomment this line if using double lanes
    // this.connectAdjacentDots();

    this.game.paths = this.removeOverlappingPaths(this.paths);


  }

  connectAdjacentDots() {


    this.game.points.forEach(point => {

      this.paths.forEach(path => {

        if (path.a.y === path.b.y) {

          if (Math.abs(path.a.y - point.y) < 100) {

            if ((path.a.x < point.x && path.b.x > point.x) || (path.b.x < point.x && path.a.x > point.x)) {
              // skipping horizontal lines
              // console.log(path);

              let otherPoint = {
                id: this.game.points.length,
                x: point.x,
                y: path.a.y
              };

              this.game.points.push(otherPoint);


              this.paths.push({a: point, b: otherPoint});
              this.paths.push({a: path.a, b: otherPoint});

              path.a = otherPoint;

            }


          }
        }

      });

    });

  }

  removeOverlappingPaths(paths) {

    let approvedPaths = [];
    paths.forEach(path => {

      if (path.force) {
        approvedPaths.push(path);
        return;
      }


      let overlaps = false;
      let i = this.game.rooms.length;

      while (i--) {

        let room = this.game.rooms[i];

        if (path.a.x < room.x && path.b.x < room.x) {
          continue;
        }

        if (path.a.x > room.x + room.width && path.b.x > room.x + room.width) {
          continue;
        }

        if (path.a.y < room.y && path.b.y < room.y) {
          continue;
        }

        if (path.a.y > room.y + room.height && path.b.y > room.y + room.height) {
          continue;
        }

        overlaps = true;

      }

      if (!overlaps) {
        approvedPaths.push(path);
      }

    });


    return approvedPaths;

  }

  generatePaths() {

    this.game.points.forEach(a => {

      let closestX = null;
      let closestY = null;
      let distanceX = null;
      let distanceY = null;

      // find points that we can reach from here, that are on the same X or Y

      // find closest on > X
      // find closest on > Y

      this.game.points.forEach(b => {
        let distance = null;

        // skip "me"
        if (a === b) { return; }

        if (a.x === b.x && a.y < b.y) {

          distance = b.y - a.y;
          if (distance < distanceY || distanceY === null) {
            closestY = b;
            distanceY = distance;
          }

        }

        if (a.y === b.y && a.x < b.x) {

          distance = b.x - a.x;
          if (distance < distanceX || distanceX === null) {
            closestX = b;
            distanceX = distance;
          }

        }

      });

      if (closestX) {
        this.paths.push({ a, b : closestX });
      }

      if (closestY) {
        this.paths.push({ a, b : closestY });
      }


    });

  }

  proposePoint(x, y, room)
  {

    let found = false;
    let foundPoint = null;

    this.game.points.forEach(point => {
      if (found) { return; }
      if (point.x === x && point.y === y) {
        found = true;
        foundPoint = point;
      }
    });

    if (found) {
      return foundPoint;
    }

    foundPoint = {x, y, room, id : this.game.points.length, paths: []};
    this.game.points.push(foundPoint);
    return foundPoint

  }
}
